import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "./assets/scss/app/main.scss";
import '@toast-ui/calendar/dist/toastui-calendar.min.css';
import "./assets/js/main";
import i18n from "./assets/translations/vue-i18n";
import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import VueApexCharts from "vue3-apexcharts";
import '@fortawesome/fontawesome-free/css/all.min.css';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
// app.use(VueApexCharts);
app.component("apexchart", VueApexCharts);
app.use(router).use(i18n).use(pinia).use(Vue3Toastify).mount("#app");

app.config.globalProperties.$devtools = true;


const tenantConfig: Record<string, any> = {
    bbq: {
        title: 'BBQ',
        favicon: '/bbq-favicon.ico'
    },
    bsg: {
        title: 'BSG',
        favicon: '/bsg-favicon.ico'
    },
    war: {
        title: 'WaR',
        favicon: ''
    }
}

const tenantKey = process.env.VUE_APP_TENANT_KEY
const config = tenantConfig[tenantKey] || tenantConfig.bsg

document.title = config.title

// FAVICON
const favicon = document.querySelector("link[rel='icon']")

if (favicon) {
    favicon.setAttribute('href', config.favicon)
} else {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = config.favicon
    document.head.appendChild(link)
}